import { skipToken, useQuery } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { Ticket } from "./apiEcms.types";

const getTechnicalRequest = async (ticketId: number, signal: AbortSignal) => {
  const { data } = await apiEcmsHttp.get<Ticket>(
    `/technical-requests/${ticketId}`,
    { signal },
  );

  return data;
};

export const useGetTechnicalRequest = (ticketId: number | undefined) =>
  useQuery({
    queryKey: [QUERY_KEYS.TECHNICAL_REQUEST, ticketId],
    enabled: Boolean(ticketId),
    queryFn: ticketId
      ? ({ signal }) => getTechnicalRequest(ticketId, signal)
      : skipToken,
    select: (data) => {
      if (data) {
        return (
          data.description
            // Keep this due to typo error in old ticket created tickets
            .replace("Coordonées", "Coordonnées")
            .replace(/<h1>/gi, "<h1 class='font-title-md'>")
            .replace(/<strong>/gi, "<strong class='font-body-default'>")
        );
      }

      return undefined;
    },
  });
